import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation('common');
  const current = i18n.language?.startsWith('zh') ? 'zh' : 'en';

  const change = (lng: 'en' | 'zh') => {
    if (lng !== current) i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-2 text-slate-500">
      <span className="hidden md:inline text-xs uppercase tracking-wide">{t('lang.switch')}</span>
      <div className="flex items-center rounded-full border border-slate-200 bg-white/70 p-0.5 text-xs">
        <button
          onClick={() => change('en')}
          className={`rounded-full px-3 py-1 font-semibold transition-colors ${
            current === 'en' ? 'bg-[#C6A87C] text-white' : 'text-slate-500 hover:text-[#C6A87C]'
          }`}
          aria-pressed={current === 'en'}
        >
          {t('lang.en')}
        </button>
        <button
          onClick={() => change('zh')}
          className={`rounded-full px-3 py-1 font-semibold transition-colors ${
            current === 'zh' ? 'bg-[#C6A87C] text-white' : 'text-slate-500 hover:text-[#C6A87C]'
          }`}
          aria-pressed={current === 'zh'}
        >
          {t('lang.zh')}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
